<template>
  <div class="wrapper container">
    <div class="content">
      <h2 class="title">极客邦个人信息保护指引</h2>
      <p class="time">生效日期：2019年9月9日</p>

      <div class="appendix-one item">
        <p class="sentence">北京极客邦科技有限公司及其关联公司（以下称为“极客邦”）尊重并保护所有使用极客邦科技网站（https://www.geekbang.org/）、极客时间网站（https://time.geekbang.org/）、InfoQ网站（https://www.infoq.cn/）、鲲鹏会网站（https://tgo.infoq.cn/）、极客时间移动应用、极客时间微信小程序以及后续由“极客邦”所有或运营的“极客邦”相关平台（以下称为 “极客邦平台”或“平台”）服务的用户（以下称为“用户”或“您”）的个人信息与个人隐私。鉴于此，根据《中华人民共和国网络安全法》等相关法律法规规定，“极客邦”制定本《极客邦个人信息保护指引》（以下称为“本指引”）。您在使用“极客邦”平台服务期间，“极客邦”将遵循本指引收集、存储、使用、管理、传输、披露、共享、保护和处理您的个人信息。本指引将帮助您了解如下内容：</p>
        <p class="sentence">1.“极客邦”如何收集您的个人信息</p>
        <p class="sentence">2.我们如何使用Cookie和同类技术</p>
        <p class="sentence">3.“极客邦”如何使用、传输、披露、共享您的个人信息</p>
        <p class="sentence">4.您如何管理或删除您的个人信息</p>
        <p class="sentence">5.关于未成年人的个人信息</p>
        <p class="sentence">6.您的个人信息存储</p>
        <p class="sentence">7.“极客邦”提供的个人信息保障措施</p>
        <p class="sentence">8.个人信息保护指引的修订</p>
        <p class="sentence">9.如何联系我们</p>
        <p class="sentence strong">请您在使用“极客邦”平台和/或服务前，完整阅读并透彻理解本指引，特别是以粗体下划线标注的条款，在您充分理解并同意后使用“极客邦”平台及服务。如果您不同意本指引的任何内容，您应立即停止使用“极客邦”的平台和/或服务。当您使用“极客邦”任一平台和/或服务时，则表示您同意且完全理解本指引的全部内容。</p>
        <p class="sentence">如您在阅读完本指引后，如您对本指引或与本指引相关的事宜有任何问题，您可通过本指引“如何联系我们”章节所列的反馈渠道联系我们，我们会尽快为您作出解答。</p>
      </div>

      <div class="one item">
        <h4 class="subtitle">第一条【“极客邦”如何收集您的个人信息】</h4>
        <p class="sentence">您的个人信息来源于您向“极客邦”提供的信息及“极客邦”通过您使用平台服务所收集到的信息：</p>
        <p class="sentence">1.您向“极客邦”提供的信息</p>
        <p class="sentence"><span class="strong">（1)您注册“极客邦”平台账号须至少向我们提供手机号、头像、昵称，并设置密码。</span>在部分单项服务中，如果您仅需使用浏览等基本服务，您不需要注册成为“极客邦”用户及提供上述信息。</p>
        <p class="sentence">（2)您如申请学生认证，为满足向您提供产品和服务之目的，除注册时提供的信息外，您还需要进一步向我们提供您的<span class="strong">真实姓名、身份证号码、学校名称、学历、入学及毕业时间、学生证等信息，</span>如果您不使用该产品和服务，则无需提供相关信息。</p>
        <p class="sentence"><span class="strong">（3）您如使用极客时间商城或购买平台的产品、服务，为确认交易状态及为您提供售后与争议解决服务之目的，除注册时提供的信息外，我们会通过您基于交易所选择的交易平台、支付机构、物流公司等收集与交易进度相关的您的交易、支付、物流信息，或将您的交易信息共享给上述服务提供者。</span>如您不使用上述服务，则无需提供上述信息。</p>
        <p class="sentence">（4）您如使用评论留言功能、极客时间部落功能，为满足向您提供产品和服务之目的，除注册时提供的信息外，会收集您发布的留言、评论信息，并展示您的昵称、头像和发布内容。</p>
        <p class="sentence">（5）您可以选择向我们主动提供您的性别信息、生日信息、学历信息、行业信息、职位信息，用以优化我们的服务。但是上述信息不是必须的，您拒绝提供不会影响到您正常使用我们的基础功能。</p>
        <p class="sentence">（6）当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
        <p class="sentence">2.“极客邦”通过您使用平台服务所收集到的信息</p>
        <p class="sentence">（1）您在使用“极客邦”平台服务时（如购买专栏或视频课程，发布评论、留言，搜索、下载内容，购买“极客邦”学员，参与直播活动、账户认证、评论、关注或被关注信息等），为满足向您提供上述服务之目的，除您在注册或开通服务时提供的个人信息外，<span class="strong">我们还可能会记录您在使用我们的平台和/或服务时提供、形成或留存的信息，包括设备型号、设备ID、日志信息、IP地址信息、手机系统和版本信息等。</span></p>
        <p class="sentence">（2）您在使用“极客邦”平台服务时，如学习专栏或视频课程，为满足向您提供学习时长统计服务之目的，除您在注册或开通服务时提供的个人信息外，<span class="strong">我们会收集您的学习记录、学习时长、登录时间、登录IP地址等信息。</span></p>
        <p class="sentence">3.来自第三方的信息</p>
        <p class="sentence">若您通过第三方账号登入平台的，“极客邦”将通过第三方获取您的昵称和头像，其他的信息以您授权第三方共享的为准。请您仔细阅读第三方的用户协议或个人信息保护政策。</p>
        <p class="sentence">4.征得授权同意的例外</p>
        <p class="sentence">根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：</p>
        <p class="sentence">（1）与国家安全、国防安全有关的；</p>
        <p class="sentence">（2）与公共安全、公共卫生、重大公共利益有关的；</p>
        <p class="sentence">（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p class="sentence">（4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
        <p class="sentence">（5）所收集的信息是您自行向社会公众公开的；</p>
        <p class="sentence">（6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；</p>
        <p class="sentence">（7）根据您的要求签订和履行合同所必需的；</p>
        <p class="sentence">（8）用于维护“极客邦”所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
        <p class="sentence">（9）为合法的新闻报道所必需的；</p>
        <p class="sentence">（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；</p>
        <p class="sentence">（11）法律法规规定的其他情形。</p>
      </div>

      <div class="two item">
        <h4 class="subtitle">第二条【我们如何使用Cookie和同类技术】</h4>
        <p class="sentence">为简化您重复登录的步骤、帮助判断您的登陆状态，我们会向您的计算机或移动设备发送一个或多个名为Cookie的小数据文件。我们不会将Cookie用于本指引所述目的之外的其他用途。您可以根据您的偏好管理或删除Cookie。</p>
      </div>

      <div class="three item">
        <h4 class="subtitle">第三条【“极客邦”如何使用、传输、披露、共享您的个人信息】</h4>
        <p class="sentence">1.为满足向您提供服务的需要</p>
        <p class="sentence strong">（1)在我们为您提供服务时，您的个人信息将被用于身份验证、客户服务、安全防范、诈骗检测、存档和备份等合理用途，确保我们向您有效的提供产品和服务以及保障服务的安全性；</p>
        <p class="sentence">（2)为提供相关服务，我们将通过您的个人信息与您联系、通知确认相关信息等；</p>
        <p class="sentence">2.提供和改进产品和服务</p>
        <p class="sentence strong">为了进一步完善产品或服务，提供更优质的用户体验，“极客邦”将使用您提供的或“极客邦”收集的信息自行或提供数据服务商进行数据统计、分析，以评估、维护和改进“极客邦”平台、产品或服务的性能，进行必要的业务运营，参与有关平台和服务的市场调研活动，开发新的平台、产品或服务，提供客户支持等。这些信息在使用前会经过匿名化的脱敏处理，将不会包含您的任何可识别的身份信息。</p>
        <p class="sentence">3.信息转移及披露</p>
        <p class="sentence">（1)数据转移</p>
        <p class="sentence">若“极客邦”或平台发生重组、合并、分立、清算或资产出售时，您的信息将作为交易的一部分转移到新的主体。我们会要求新的持有您个人信息的公司、组织继续受本指引的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</p>
        <p class="sentence">（2)数据披露、共享</p>
        <p class="sentence">基于国家、公共利益及安全，依照法律及合法程序，“极客邦”将向有权的司法机关、行政机关或有关个人披露您的个人信息，或依照法院裁决、判决或政府机关的强制要求执行相关行为。请您知悉，上述国家包括但不限于中华人民共和国或其他“极客邦”开展业务的国家及相关法律法规。为维护第三人的合法利益，或调查、预防或处理违法、违规、侵权、安全或技术方面的问题或学术研究等合理之目的等情形下而使用、共享、披露您的个人信息。</p>
        <p class="sentence strong">基于为您提供商城服务，“极客邦”将会向快递公司等必要服务方披露、共享您的收件人、收件电话、收件地址、支付信息等必要信息。如果您不使用商城服务，则不会披露上述信息。</p>
      </div>

      <div class="four item">
        <h4 class="subtitle">第四条【您如何管理或删除您的个人信息】</h4>
        <p class="sentence">您可以在我们系统中查阅或删除您的订阅、购买、收藏、发布的内容、课程、专栏、评论、留言；您也可以通过解除绑定、修改个人设置、删除相关信息等方式撤回部分授权，也可以通过注销账号的方式撤销所有授权或服务；请知悉，当您撤回同意或授权后，可能将导致“极客邦”无法继续为您提供服务。</p>
      </div>

      <div class="five item">
        <h4 class="subtitle">第五条【第三方服务】</h4>
        <p class="sentence">若您是通过“极客邦”开放API/SDK接口在第三方平台或渠道接受平台的信息或内容的，第三方行为的约束以其平台公示的相关政策或您与第三方平台签署的相关协议约定为准，“极客邦”不承担第三方平台的任何行为导致的任何责任。</p>
      </div>

      <div class="six item">
        <h4 class="subtitle">第六条【关于未成年人的个人信息】</h4>
        <p class="sentence strong">“极客邦”非常重视对未成年人信息的保护。若您是18周岁以下的未成年人，请您及您的监护人仔细阅读本个人信息保护指引，并在征得您的监护人同意的前提下使用“极客邦”平台和/或服务，在您提交个人信息之前，应寻求父母或监护人的同意和指导。</p>
      </div>

      <div class="seven item">
        <h4 class="subtitle">第七条【您的个人信息存储】</h4>
        <p class="sentence">请您知悉，“极客邦”将收集到的用户个人信息存储于中华人民共和国境内的服务器内。</p>
      </div>

      <div class="eight item">
        <h4 class="subtitle">第八条【“极客邦”提供的个人信息保障措施】</h4>
        <p class="sentence">我们将采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会以高度的勤勉义务对待您的信息，未经您同意，我们不会向任何第三方共享您的信息。也请您使用复杂密码并妥善保管您的账户及密码，并谨慎向第三方提供您的个人信息。如您发现自己的个人信息泄密，尤其是你的账户及密码发生泄露，请您立即联络我方客服，以便我方采取相应措施。</p>
      </div>

      <div class="nine item">
        <h4 class="subtitle">第九条【个人信息保护指引的修订】</h4>
        <p class="sentence">为了给您提供更好的服务，我们可能会根据产品或服务的更新情况及法律法规的相关要求适时修改本指引的条款，该等修改构成本指引的一部分。如该等更新造成您在本指引下权利的实质减少或重大变更，我们将在本指引生效前通过公告、推送通知、弹窗提示或其他方式来通知您，您如果不同意该等变更，可以选择停止使用“极客邦”服务；如您仍然继续使用“极客邦”服务的，即表示您已充分阅读、理解并同意受经修订的本指引的约束。</p>
      </div>

      <div class="ten item">
        <h4 class="subtitle">第十条【如何联系我们】</h4>
        <p class="sentence strong">如您对本指引有任何疑问、建议或意见的，或您发现您的个人信息可能被泄露的，您可以通过如下任意一种方式联系我们，一般情况下，我们将在收到您的问题、意见或建议，并验证您的用户身份后的十五个工作日内予以回复：</p>
        <p class="sentence strong">1.发送邮件至legal@geekbang.com。</p>
        <p class="sentence strong">2.可通过客服热线或app内在线客服联系我们 。</p>
      </div>

      <div class="eleven item">
        <h4 class="subtitle">第十一条【法律适用及管辖】</h4>
        <p class="sentence">本协议签订地为中华人民共和国北京市朝阳区。</p>
        <p class="sentence strong">本指引的生效、履行、解释及争议的解决，您因使用“极客邦”平台或服务而产生或与本指引相关的一切争议、权利主张或其他事项，均适用中华人民共和国法律（不包括冲突法和港澳台地区法律及规定）。因本指引引起的或与本指引有关的任何争议，均提请北京仲裁委员会按照其仲裁规则进行仲裁。仲裁地点为北京，仲裁语言为中文。仲裁裁决是终局的，对各方均有约束力。</p>
        <p class="sentence strong">请您再次确认您已全部阅读并充分理解上述条款。</p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
@import "../../style/bulma/app.sass"
.content
  width: 775px
  margin: 0 auto
  margin-bottom: 40px
  font-family: PingFang SC
  +mobile
    width: 100%
  .strong
    font-weight: 600
  .title
    margin-top: 64px
    font-weight: bold
  .time
    text-align: right
  .item
    .subtitle
      font-weight: bold
      margin-top: 30px
      border-left: 3px solid $primary3
      padding-left: 10px
      margin-bottom: 18px
</style>
